import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Lang, SUPPORTED_LANGUAGES } from '@src/i18n/lang';
import { siteLanguage } from '@src/site';
import en from '@src/i18n/locales/en.json';
import ru from '@src/i18n/locales/ru.json';

/**
 * Language follows the site, then the `lang` cookie on .ru: .com is always
 * English (no switcher), .ru defaults to Russian and can toggle. No
 * browser-language detection — the two sites are separate products, and the
 * .com site must never surface anything Russian (see .cursor/rules/dotcom-no-russia).
 */
export function initI18n(lng: Lang = siteLanguage()) {
  document.documentElement.lang = lng;
  // Vite keeps the i18next singleton across SSR module reloads. Refresh its
  // bundles from the current imports so HTML never uses stale translations.
  if (i18n.isInitialized) {
    i18n.addResourceBundle(Lang.RU, 'translation', ru, false, true);
    i18n.addResourceBundle(Lang.EN, 'translation', en, false, true);
    return i18n.changeLanguage(lng);
  }
  return i18n.use(initReactI18next).init({
    resources: {
      [Lang.RU]: { translation: ru },
      [Lang.EN]: { translation: en },
    },
    lng,
    // English, not Russian: a missing key must never fall back to Russian text,
    // because that text would render on the .com site.
    fallbackLng: Lang.EN,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      // React escapes for us.
      escapeValue: false,
    },
  });
}

export default i18n;
